module.exports = __webpack_public_path__ + "DINNextLTPro-BlackCondensed.ttf?bec05c87705af625bb5d8a7c431b6122";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BlackCondensed.ttf
// module id = 1375
// module chunks = 0